/**
 * Keep in sync with `backend/src/constants/examinerRole.ts`.
 */
export class ExaminerRoles {
  static readonly examiner = 'examiner' as const
  static readonly moderator = 'moderator' as const
  static readonly admin = 'admin' as const
  static readonly superuser = 'superuser' as const

  static readonly all = [
    ExaminerRoles.examiner,
    ExaminerRoles.moderator,
    ExaminerRoles.admin,
    ExaminerRoles.superuser
  ] as const

  static is(value: unknown): value is ExaminerRole {
    return typeof value === 'string' && (ExaminerRoles.all as readonly string[]).includes(value)
  }
}

export type ExaminerRole = (typeof ExaminerRoles.all)[number]
